import styled from 'styled-components';

const UpcomingPharmacyOrdersStyled = styled.div`
  .verification-status {
    max-width: 110px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    line-height: 18px;
    border-radius: 4px;
    height: 20px;
    padding: 1px 10px;
    margin-top: 6px;
    margin-right: 4px;
    @media (max-width: 360px) {
      margin-right: 0px;
    }
  }
  .upcomingOrdersSlider {
    margin-bottom: 30px;
    margin-top: 6px;

    .slick-arrow {
      &:before {
        content: '';
      }
    }
    .slick-dots {
      li {
        &.slick-active {
          button {
            width: 30px;
            background: ${(props) => props.theme.green?.dark};

            &:before {
              opacity: 0.75;
              color: black;
            }
          }
        }
      }
    }
    .item {
      padding: 0 10px;
      @media (max-width: 430px) {
        padding: 0 27px;
      }

      .orderBox {
        padding-right: 25px;
        padding-bottom: 10px;
        background: #ffffff;
        border: 1px solid #d0dae4;
        border-radius: 8px;
        width: 350px;
        height: 116px;
        @media (max-width: 390px) {
          width: 336px;
        }
        @media (max-width: 375px) {
          width: 316px;
        }
        @media (max-width: 360px) {
          width: 305px;
        }

        .deliveryTimeBox {
          padding: 5px 8px 9px 12px;
          border: 1px solid #e3e9ef;
          border-radius: 7px 7px 0 0;
          border-top: 0;
          width: calc(100% + 26.5px);

          .statusAndTime {
            display: flex;
            justify-content: space-between;
            align-items: baseline;

            .bold {
              font-weight: 600;
            }

            .statusRx {
              display: flex;
              justify-content: flex-start;
              align-items: center;

              .roundDivider {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #e3e9ef;
                margin-right: 8px;
              }

              .mr {
                margin-right: 0.5rem;
              }
            }
          }
          .deliveryTime {
            font-weight: 600;
            font-size: 13px;
            line-height: 18px;
            font-style: normal;
            color: ${(props) => props?.theme?.text?.dark};
          }
          .standardDelivery {
            display: flex;
            flex-direction: column;

            .text {
              font-weight: 400;
              font-size: 12px;
              line-height: 15px;
              color: #78909c;
              margin-bottom: 3px;
            }
            .dateAndTime {
              font-weight: 600;
              font-size: 14px;
              line-height: 18px;
              color: ${(props) => props?.theme?.text?.dark};
              @media (max-width: 360px) {
                font-size: 13px;
              }

              .eclipse {
                display: inline-block;
                background: #d0dae4;
                width: 6px;
                height: 6px;
                border-radius: 3px;
                margin-bottom: 2px;
                margin: 0 8px 2px 8px;
              }
            }
          }
        }
        .no-padding {
          padding: 8px 10px 2px 10px !important;
        }
        .shipmentBox {
          display: flex;
          flex-direction: row;
          padding: 4px 10px 10px 10px;
          padding-left: 15px;
          align-items: center;

          &.express {
            padding-top: 5px !important;
            padding-bottom: 5px !important;
          }
          .expressImage {
            width: 25%;
            margin-right: 15px;
            margin-top: 5px;

            .expressBadge {
              display: flex;
              background: no-repeat;
              background-size: cover;
              flex-direction: row;
              height: 13px;
              width: 100%;
              display: flex;
            }
            .expressImg {
              position: relative;
              top: -5px;
            }
          }
          .deliverySection {
            width: 100%;
            margin-bottom: 10px;

            .deliveryDetails {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: flex-start;

              .shipmentDetails {
                width: 150px;
                .rxPadding {
                  padding-top: 0 !important;
                }
                .shipmentTitle {
                  font-weight: 700;
                  font-size: 14px;
                  line-height: 18px;
                  padding-top: 10px;

                  .itemInfo {
                    display: flex;
                    justify-content: space-between;
                  }

                  .itemName {
                    flex: none;
                    margin-top: 3px;
                    font-weight: 600;
                    width: 191px;
                    font-size: 12px;
                    line-height: 15px;
                    color: #78909c;
                    @media (max-width: 375px) {
                      width: 172px;
                    }
                    @media (max-width: 360px) {
                      width: 164px;
                    }
                  }

                  .itemNameRx {
                    display: flex;
                    align-items: center;
                    margin-left: -4px;
                  }

                  span {
                    margin-left: 4px;
                  }
                }
                .quantity {
                  display: flex;
                  flex: none;
                  margin-left: 2px;
                }
                .itemsQuantity {
                  font-weight: 600;
                  font-size: 13px;
                  line-height: 16px;
                  color: #63778b;
                }
                .express {
                  margin-top: 2px;
                }
                .totalItems {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 16px;
                  margin-bottom: 8px;
                  color: #78909c;
                }
                .standardItem {
                  margin-right: 10px;
                }
              }

              .orderStatus {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
              }
            }
          }
        }
      }
    }
    .erxBox {
      border: 1px solid rgba(185, 129, 28, 0.5) !important;
    }

    .expressBox {
      border: 1px solid ${(props) => props.theme.colors.primary.green['400']} !important;
    }

    .flashBox {
      border: 1px solid ${(props) => props.theme.colors.accent.yellow['400']} !important;
    }
  }

  @media (max-width: 420px) {
    .upcomingOrdersSlider {
      .slick-slide {
        width: 92vw !important;
      }
      margin-top: 5px;
      .slick-arrow {
        &.slick-prev {
          left: 2.5px;
        }
        &.slick-next {
          right: 0px;
        }
      }
      .slick-dots {
        width: 14.5rem;
        overflow: hidden;
        margin: auto;
        position: relative;
      }
      .item {
        padding: 0 6px;
      }
    }
    .item {
      padding: 0 7px;
      .orderBox {
        margin-left: 6px;
        padding-right: 0;
        .deliveryTimeBox {
          width: 350px;
        }
        .deliverySection {
          .deliveryDetails {
            .shipmentDetails {
              .shipmentTitle {
                width: 150px;
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 430px) {
    .upcomingOrdersSlider {
      .slick-slide {
        width: 92vw !important;
        .slick-arrow {
          &.slick-prev {
            left: 2.5px;
          }
          &.slick-next {
            right: 0px;
          }
        }
      }
    }
  }
  @media (max-width: 480px) {
    .slick-arrow {
      &.slick-prev {
        left: 2.5px;
      }
      &.slick-next {
        right: 0px;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1124px) {
    .upcomingOrdersSlider {
      .slick-arrow {
        &.slick-prev {
          left: 1px;
        }
        &.slick-next {
          right: 2px;
        }
      }
      .item {
        .orderBox {
          .deliverySection {
            .deliveryDetails {
              .shipmentDetails {
                .shipmentTitle {
                  min-width: 150px;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default UpcomingPharmacyOrdersStyled;
